import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AmountAggregatorInstance  {
    _originalTypeClassName = "zERP.BO.AmountAggregatorInstance";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AmountAggregatorInstance.translate = translateService;
}
this.AmountAggregator = new Domain.AmountAggregator();
this.Entries = [];
this.Id = null;
this.CurrentValue = null;
this.DateFrom = null;
this.DateTo = null;
this.LastUpdate = null;
this.RunningValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CurrentValue:any;
DateFrom:any;
DateTo:any;
LastUpdate:any;
RunningValue:any;
AmountAggregator:any;
Entries:any;
FiscalYear:any;
static setAmountAggregator = ($this, value) => {
var oldValue = $this.AmountAggregator;
$this.AmountAggregator = value;
if (value != null) {
}
}
static setEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Entries == null) $this.Entries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Entries.length > 0) {
                    Domain.AmountAggregatorInstance.removeEntries($this, $this.Entries[0]);
                }

                Domain.AmountAggregatorInstance.addManyEntries($this, copyItems);
            }
static addManyEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AmountAggregatorInstance.addEntries($this, items[i]);
                }
            }
static addEntries = ($this, item) => {
                if ($this.Entries == null) $this.Entries = [];
                if (item == null || $this.Entries.indexOf(item) > -1) return;
                $this.Entries.push(item);
}
static addRangeEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AmountAggregatorInstance.addEntries($this, item));
            }
static removeEntries = ($this, item) => {
                if ($this == null || $this.Entries == null || $this.Entries.indexOf(item) === -1) return;
                var _index = $this.Entries.indexOf(item);
                $this.Entries.splice(_index, 1);
}
static clearEntries = ($this) => { $this.Entries = null; }
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}